import { HStack, Link } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { ListTreeIcon, MessageIcon, ProfileIcon } from 'components/icons';
import React from 'react';
import { generatePath } from 'react-router-dom';
import {
  CANONICAL_PERSON_PATH,
  INNER_CHAT_LOOKUP_DIRECT_PATH,
  MEMBER_PATH,
} from 'utils/routes';
import { UserInfoActionButton } from './Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useSession } from 'utils/sessionProvider';

type UserInfoPopoverActionsProps = {
  email: string;
  memberId: string;
  familyMemberId?: string;
  showLinkToGlobalMemberProfile?: boolean;
};

export const UserInfoActions = ({
  email,
  memberId,
  familyMemberId,
  showLinkToGlobalMemberProfile,
}: UserInfoPopoverActionsProps) => {
  const { genealogy } = useSession();
  return (
    <HStack wrap="wrap" spacing={2}>
      <UserInfoActionButton
        icon={<MessageIcon />}
        aria-label={t`Send message`}
        as={Link}
        toChat={generatePath(INNER_CHAT_LOOKUP_DIRECT_PATH, {
          lookupId: memberId,
        })}
      />
      <UserInfoActionButton
        as={Link}
        aria-label={t`Send email`}
        toMail={email}
        icon={<FontAwesomeIcon icon={light('envelope')} />}
      />
      {!!showLinkToGlobalMemberProfile && (
        <UserInfoActionButton
          as={Link}
          aria-label={t`View user`}
          to={generatePath(MEMBER_PATH, { memberId })}
          icon={<ProfileIcon />}
        />
      )}
      {familyMemberId && genealogy.active && (
        <UserInfoActionButton
          as={Link}
          aria-label={t`View in Family Tree`}
          to={{
            pathname: generatePath(CANONICAL_PERSON_PATH, {
              personId: familyMemberId,
            }),
          }}
          icon={<ListTreeIcon />}
        />
      )}
    </HStack>
  );
};
